// extracted by mini-css-extract-plugin
export default {"root":"aNPdKxlh","preview":"haM4SCte"};